import { useStylesHook } from "../hooks/useStylesHook";
import { hexToRGB, tone } from "../theming/colors";
import { Client } from "../theming/ThemeProvider";
import { PORTAL_THEME, TMS_THEME } from "../theming/theming";
import { useThemeContext } from "../theming/useThemeContext";
export function useButtonClasses(type, block) {
    const { client, buttonStyles } = useThemeContext();
    let button = {};
    if (client === Client.Portal) {
        button = {
            ...button,
            padding: [5, 10],
            fontWeight: PORTAL_THEME.typography.strong.fontWeight,
            borderColor: "rgba(0,0,0,0)",
            fontSize: PORTAL_THEME.typography.strong.fontSize,
            "&:hover:enabled": {
                color: PORTAL_THEME.palette.primary.base.color,
                backgroundColor: PORTAL_THEME.palette.gray.fog.color,
                borderColor: "rgba(0,0,0,0)",
                borderRadius: `${buttonStyles?.default?.borderRadius ?? TMS_THEME.root.borderRadius}`,
                textDecoration: "none",
            },
            "&:hover": {
                color: PORTAL_THEME.palette.primary.base.color,
                backgroundColor: PORTAL_THEME.palette.gray.fog.color,
                borderColor: "rgba(0,0,0,0)",
                borderRadius: `${buttonStyles?.default?.borderRadius ?? TMS_THEME.root.borderRadius}`,
                textDecoration: "none",
            },
            "&:focus:active:enabled": {
                color: PORTAL_THEME.palette.primary.base.color,
                backgroundColor: PORTAL_THEME.palette.gray.fog.color,
                borderColor: "rgba(0,0,0,0)",
            },
            "&:focus": {
                color: PORTAL_THEME.palette.primary.base.color,
                backgroundColor: PORTAL_THEME.palette.gray.fog.color,
                borderColor: "rgba(0,0,0,0)",
                textDecoration: "none",
            },
            "&[disabled]:hover": {
                borderColor: "rgba(0,0,0,0)",
            },
            borderRadius: buttonStyles?.default?.borderRadius ?? TMS_THEME.root.borderRadius,
            color: PORTAL_THEME.palette.primary.base.color,
            backgroundColor: PORTAL_THEME.palette.gray.white.color,
        };
        if (type === "primary") {
            const alternateState = {
                color: buttonStyles?.primary?.color,
                backgroundColor: tone(buttonStyles?.primary?.backgroundColor ?? "", -15),
                borderColor: "rgba(0,0,0,0)",
                textDecoration: "none",
                borderRadius: buttonStyles?.primary?.borderRadius ?? TMS_THEME.root.borderRadius,
            };
            button = {
                ...button,
                boxShadow: BUTTON_BOX_SHADOW,
                color: buttonStyles?.primary?.color,
                backgroundColor: buttonStyles?.primary?.backgroundColor,
                "&:hover:enabled": alternateState,
                "&:hover": alternateState,
                "&:focus:active:enabled": alternateState,
                "&:focus:enabled": alternateState,
                "&:focus": alternateState,
                "&:active:enabled": alternateState,
                "&[disabled]:hover": {
                    color: buttonStyles?.primary?.color,
                    backgroundColor: buttonStyles?.primary?.backgroundColor,
                },
                textDecoration: "none",
            };
        }
        if (type === "default") {
            button = {
                ...button,
                boxShadow: `0px 2px 4px rgba(${hexToRGB(PORTAL_THEME.palette.gray.slate.color)}, 0.2)`,
            };
        }
        if (type === "suppressed") {
            button = {
                ...button,
                color: PORTAL_THEME.palette.primary.base.color,
                backgroundColor: "transparent",
                padding: [5, 0],
            };
        }
    }
    if (block) {
        button = {
            ...button,
            display: "block",
            width: "100%",
        };
    }
    return useStylesHook({ button, baseButton: BASE_BUTTON });
}
export const BUTTON_OUTLINE = {
    outlineWidth: 2,
    outlineStyle: "auto",
    outlineColor: "#cbe1f7",
    outlineOffset: 0,
};
export const BASE_BUTTON = {
    display: "inline-block",
    marginBottom: 0,
    textAlign: "center",
    cursor: "pointer",
    fontWeight: 500,
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    touchAction: "manipulation",
    backgroundImage: "none",
    lineHeight: 1.42857,
    userSelect: "none",
    "-webkit-appearance": "button",
    "&:focus:enabled": BUTTON_OUTLINE,
    "&:focus": BUTTON_OUTLINE,
    "&:focus:active": BUTTON_OUTLINE,
    "&:active": BUTTON_OUTLINE,
};
export const BUTTON_BOX_SHADOW = `0px 2px 4px rgba(${hexToRGB(PORTAL_THEME.palette.gray.slate.color)}, 0.2)`;
